export default "__VITE_ASSET__CReky4AC__"